const ContactConfig = {
  collection: "contacts",
  fields: ["id", "status", "job_title", "name", "email", "phone", "extension"],

  filter: "filter[status][_eq]=active",

  adapter: class Contact {
    constructor(contact) {
      this.id = contact.id;
      this.status = contact.status;
      this.job_title = contact.job_title;
      this.name = contact.name;
      this.email = contact.email;
      this.phone = contact.phone;
      this.extension = contact.extension || undefined;
    }
  }
};

export default ContactConfig;
